// 团购
export const GTM_DEFAULT_ARGUS = {
  id: 'GTM-TXW84QW',
  dataLayerName: 'haomao',
};

// 拼音课
export const GTM_PINYIN_ARGUS = {
  id: 'GTM-5Q99G9H',
};

// 数学课
export const GTM_MATH_ARGUS = {
  id: 'GTM-ND4WDXS',
};

// WK Chinese Form （自定义事件 前缀 CF、双课落地页前缀 CF_CM）
export const GTM_CHINESEFORM_ARGUS = {
  id: 'GTM-PSTZVHG',
};

// 学员中心 数学约课
export const STUDENT_MATH_PRD_URL = 'https://student.wukongedu.net/en/reserve';
export const STUDENT_MATH_DEV_URL = 'https://student-dev.wukongedu.net/en/reserve';
// 官网隐藏地址
export const PRIVACY_AGREEMENT_URL = 'https://www.wukongsch.com/policy';
// next语言
export const CURRENT_LANGUAGE = 'NEXT_LOCALE';
// 官网地址
export const OFFICIAL_WEBSITE_URL = 'https://www.wukongsch.com';
// 双课落地页
export const REPORT_PAGE_NAME_CHINESE_MATH_CLASS = 'FORM_CHINESE_MATH_CLASS';
export const OFFICIAL_WEBSITE_EN_URL = 'https://www.wukongsch.com/en';
// 二维码默认中文
export const QR_CODE_CHINESE = 'https://cdnwukong.com/images/form/imgs/public-form-qrcode.png';
// 二维码默认数学
export const QR_CODE_MATH = 'https://cdnwukong.com/images/form/imgs/public-form-qrcode.png';

// 企微 结果页 多语言
export const LANDING_RESULT_EN = {
  btnPickUp: 'Get it Free Now',
  pickUpReminder: 'Click the button to <span>learn free</span> immediately',
  modelTitle: 'Add WeChat to get the course',
  pickUpReminderLongPress: 'Scan the QR code and <span>learn free</span> immediately',
  ScanningReminderLongPress: 'Scan the QR code and <span>learn free</span> immediately',
  modelCourseName: 'Additional Rewards',
  modelCourseNameMath: 'WuKong mathematics exercises',
};
export const LANDING_RESULT_ZH = {
  btnPickUp: '立即领取',
  pickUpReminder: '<span>点击上方按钮</span> 立即开通课程',
  modelTitle: '添加老师微信 开通课程',
  pickUpReminderLongPress: '长按识别二维码，立即免费学习',
  ScanningReminderLongPress: '<span>微信扫码</span> 立即解锁全部福利',
  modelCourseName: '领取配套学习福利',
  modelCourseNameMath: '40道《悟空数学趣味练习册》',
};
// 邮件一键激活
export const REPORT_PAGE_NAME_EDM_FEEDBACK = 'FORM_EDM_FEEDBACK';
